/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.HcpController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { AddressInfo } from '../models/address-info';
import { CertificateInfoResponse } from '../models/certificate-info-response';
import { ContactDetailsModel } from '../models/contact-details-model';
import { GetHcpDetailsResponse } from '../models/get-hcp-details-response';
import { PersonDetailsResponse } from '../models/person-details-response';

@Injectable()
export class HcpApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getHcp(spinnerMessage: string = null): Observable<GetHcpDetailsResponse> {
        return this.httpClient.get<GetHcpDetailsResponse>(`/api/hcp`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getAddressInfo(postalcode: string, housenumber: string, housenumberAddition: string, spinnerMessage: string = null): Observable<AddressInfo> {
        return this.httpClient.get<AddressInfo>(`/api/hcp/addressinfo?postalcode=${encodeURIComponent(postalcode)}&housenumber=${encodeURIComponent(housenumber)}&housenumberAddition=${encodeURIComponent(housenumberAddition)}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getPersonDetails(spinnerMessage: string = null): Observable<PersonDetailsResponse> {
        return this.httpClient.get<PersonDetailsResponse>(`/api/hcp/persondetails`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getCertificateInfo(caseId: number, spinnerMessage: string = null): Observable<CertificateInfoResponse> {
        return this.httpClient.get<CertificateInfoResponse>(`/api/hcp/certificateinfo?caseId=${caseId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


    public updateContactDetails(contactDetails: ContactDetailsModel, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/hcp/contactdetails`, contactDetails,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
